import EasyGatewayPay from 'modules/easyPay/indexEasyGateway'

export default function EasyGatewayPayPage() {
    return (
        <>
            <EasyGatewayPay />
        </>
    )
}
